/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Otp } from "../../Otp";
import { getApplicantInfo } from "../../../store/selectors/appConfig";
import { StyledComeBackVerificationComponent } from "./../styled";
import { UAE_CODE } from "../../../constants";

export const ComeBackVerificationComponent = ({
  redirectRoute,
  otpType,
  roInviteProp,
  partnerInviteProp
}) => {
  const { mobileNo, email, countryCode } = useSelector(getApplicantInfo);
  const [countryCodeValue, setCountryCodeValue] = useState(UAE_CODE);
  const [mobileNumber, setMobileNumber] = useState("");
  const [emailId, setEmailId] = useState("");

  const suffixNumberStyle = {
    color: "#5E080B",
    fontWeight: 500,
    display: "inline-block"
  };

  useEffect(() => {
    if (!partnerInviteProp) {
      setCountryCodeValue(countryCode);
      setMobileNumber(mobileNo);
      setEmailId(email);
      return;
    }
    const {
      mobileNo: partnerMobileNo,
      email: partnerEmail,
      countryCode: partnerCountryCode
    } = partnerInviteProp;
    setCountryCodeValue(partnerCountryCode);
    setMobileNumber(partnerMobileNo);
    setEmailId(partnerEmail);
  }, []);

  return (
    <StyledComeBackVerificationComponent>
      <Otp
        redirectRoute={redirectRoute}
        otpType={otpType}
        title={
          otpType === "sms" ? "Let's verify your mobile number" : "Let's verify your email address"
        }
        info={
          otpType === "sms" ? (
            <span>
              We sent a 6-digits One Time Password (OTP) to the number{" "}
              <span style={suffixNumberStyle}> {`+${countryCodeValue} ${mobileNumber}`}</span>.
              Please enter it below.
            </span>
          ) : (
            <span>
              We sent a 6-digits One Time Password (OTP) to{" "}
              <span style={suffixNumberStyle}>{emailId}</span>. Please enter it below. Don't see the
              email? Try checking your spam or junk folder.
            </span>
          )
        }
        changeText={otpType === "sms" ? "Change mobile number" : "Change email"}
        roInviteProp={roInviteProp}
        heading={<h3 className={"heading"}>Confirm that it’s you</h3>}
        partnerInviteProp={partnerInviteProp}
      />
    </StyledComeBackVerificationComponent>
  );
};
